import Swal from "sweetalert2";

export default {
  install(Vue, options = {}) {
    Vue.prototype.$message = (msg, userOptions) => {
      return Vue.$alert(msg, "", "info", userOptions);
    };

    Vue.prototype.$message.info = (title, msg, userOptions = {}) => {
      return Vue.$alert(title, msg, "info", userOptions);
    };
    Vue.prototype.$message.success = (title, msg, userOptions = {}) => {
      return Vue.$alert(title, msg, "success", userOptions);
    };
    Vue.prototype.$message.error = (title, msg, userOptions = {}) => {
      return Vue.$alert(title, msg, "error", userOptions);
    };
    Vue.prototype.$message.warning = (title, msg, userOptions = {}) => {
      return Vue.$alert(title, msg, "warning", userOptions);
    };

    Vue.$message = Vue.prototype.$message;

    //alert
    Vue.prototype.$alert = (title, msg, type, userOptions = {}) => {
      const alertOption = {
        title: title || "",
        text: msg,
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: "確定",
        icon: type || "info"
      };
      Object.keys(userOptions).forEach(key => {
        alertOption[key] = userOptions[key];
      });
      return new Promise((res, rej) => {
        Swal.fire(alertOption).then(resp => {
          res(resp.value);
        });
      });
    };
    Vue.prototype.$alert.info = (title, msg, userOptions = {}) => {
      return Vue.$alert(title, msg, "info", userOptions);
    };
    Vue.prototype.$alert.success = (title, msg, userOptions = {}) => {
      return Vue.$alert(title, msg, "success", userOptions);
    };
    Vue.prototype.$alert.error = (title, msg, userOptions = {}) => {
      return Vue.$alert(title, msg, "error", userOptions);
    };
    Vue.prototype.$alert.warning = (title, msg, userOptions = {}) => {
      return Vue.$alert(title, msg, "warning", userOptions);
    };

    //confirm
    Vue.prototype.$confirm = (title, msg, type, userOptions = {}) => {
      const alertOption = {
        title: title || "",
        text: msg,
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: "確定",
        showCancelButton: true,
        cancelButtonText: "取消",
        icon: type || "question"
      };
      Object.keys(options).forEach(key => {
        alertOption[key] = options[key];
      });
      return new Promise((res, rej) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-cathay mr-1 ml-1",
            cancelButton: "btn btn-danger mr-1 ml-1"
          },
          buttonsStyling: false
        })
          .fire(alertOption)
          .then(resp => {
            res(resp.value);
          });
      });
    };

    Vue.$alert = Vue.prototype.$alert;
    Vue.$confirm = Vue.prototype.$confirm;
  }
};
